import { Record, Union } from "./fable_modules/fable-library.3.7.1/Types.js";
import { record_type, string_type, union_type } from "./fable_modules/fable-library.3.7.1/Reflection.js";
import { append, singleton, empty, tail, head, isEmpty, ofArray } from "./fable_modules/fable-library.3.7.1/List.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "./fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { map, defaultArgWith } from "./fable_modules/fable-library.3.7.1/Option.js";
import { Cmd_ofSub } from "./fable_modules/Feliz.Router.3.8.0/../Fable.Elmish.4.0.0-beta-3/cmd.fs.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Home", "Basic", "Groups", "Ordering", "Pinning", "Resizing", "EditableData", "Expanding", "Grouping", "PaginationControlled", "Sorting"];
    }
}

export function Page$reflection() {
    return union_type("Router.Page", [], Page, () => [[], [], [], [], [], [], [], [], [], [], []]);
}

export class Link extends Record {
    constructor(Name, Page) {
        super();
        this.Name = Name;
        this.Page = Page;
    }
}

export function Link$reflection() {
    return record_type("Router.Link", [], Link, () => [["Name", string_type], ["Page", Page$reflection()]]);
}

export const links = ofArray([new Link("Home", new Page(0)), new Link("Basic", new Page(1)), new Link("Column Groups", new Page(2)), new Link("Column Ordering", new Page(3)), new Link("Column Pinning", new Page(4)), new Link("Column Resizing", new Page(5)), new Link("Editable Data", new Page(6)), new Link("Expanding", new Page(7)), new Link("Grouping", new Page(8)), new Link("Pagination Controlled", new Page(9)), new Link("Sorting", new Page(10))]);

export const PageModule_defaultPage = new Page(0);

export function PageModule_parseUrlSegment(_arg1) {
    let pattern_matching_result;
    if (!isEmpty(_arg1)) {
        if (head(_arg1) === "basic") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "groups") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "ordering") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 2;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "pinning") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "resizing") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 4;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "editableData") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 5;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "expanding") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 6;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "grouping") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 7;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "paginationControlled") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 8;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else if (head(_arg1) === "sorting") {
            if (isEmpty(tail(_arg1))) {
                pattern_matching_result = 9;
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else {
            pattern_matching_result = 10;
        }
    }
    else {
        pattern_matching_result = 10;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page(1);
        }
        case 1: {
            return new Page(2);
        }
        case 2: {
            return new Page(3);
        }
        case 3: {
            return new Page(4);
        }
        case 4: {
            return new Page(5);
        }
        case 5: {
            return new Page(6);
        }
        case 6: {
            return new Page(7);
        }
        case 7: {
            return new Page(8);
        }
        case 8: {
            return new Page(9);
        }
        case 9: {
            return new Page(10);
        }
        case 10: {
            return PageModule_defaultPage;
        }
    }
}

export function PageModule_noQueryString(segments) {
    return [segments, empty()];
}

export function PageModule_toUrlSegments(page) {
    return PageModule_noQueryString((page.tag === 1) ? singleton("basic") : ((page.tag === 2) ? singleton("groups") : ((page.tag === 3) ? singleton("ordering") : ((page.tag === 4) ? singleton("pinning") : ((page.tag === 5) ? singleton("resizing") : ((page.tag === 6) ? singleton("editableData") : ((page.tag === 7) ? singleton("expanding") : ((page.tag === 8) ? singleton("grouping") : ((page.tag === 9) ? singleton("paginationControlled") : ((page.tag === 10) ? singleton("sorting") : singleton("")))))))))));
}

export function Router_goToUrl(e) {
    e.preventDefault();
    RouterModule_nav(singleton(e.currentTarget.attributes.href.value), 1, 1);
}

export function Router_navigatePage(page) {
    const tupledArg = PageModule_toUrlSegments(page);
    const queryString = tupledArg[1];
    defaultArgWith(map((tupledArg_1) => {
        RouterModule_nav(append(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
    }, RouterModule_trySeparateLast(tupledArg[0])), () => {
        RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString)), 1, 1);
    });
}

export function Cmd_navigatePage(page) {
    const tupledArg = PageModule_toUrlSegments(page);
    return Cmd_ofSub((_arg9) => {
        const queryString_1 = tupledArg[1];
        defaultArgWith(map((tupledArg_1) => {
            RouterModule_nav(append(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString_1))), 1, 1);
        }, RouterModule_trySeparateLast(tupledArg[0])), () => {
            RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString_1)), 1, 1);
        });
    });
}

//# sourceMappingURL=Router.fs.js.map
